var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('detail-banner',{attrs:{"sightName":_vm.sightName,"bannerImg":_vm.bannerImg,"bannerImgs":_vm.gallaryImgs}}),_c('detail-header'),_c('div',{staticClass:"content"},[_c('detail-list',{attrs:{"list":_vm.categoryList}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }